import { Component } from '@angular/core';


@Component({
  selector: 'render-svg-sprite',
  templateUrl: 'svg-sprite.component.html'
})

export class RenderSvgSpriteComponent {
}
